import {
  ADMIN_SETTINGS_FIELD_HELP,
  type AdminSettingsFieldHelpKey,
} from "../lib/adminSettingsFieldHelp";
import { HelpTooltip } from "./HelpTooltip";

type Props = {
  helpKey: AdminSettingsFieldHelpKey;
  children: string;
};

/**
 * Etykieta pola ustawień z ikonką „?" i dymkiem wyjaśnienia.
 * Zastępuje zwykły <div>Etykieta</div> wewnątrz <label className="admin-field-block">.
 */
export function FieldLabel({ helpKey, children }: Props) {
  return (
    <div className="field-label-row">
      <span>{children}</span>
      <HelpTooltip
        text={ADMIN_SETTINGS_FIELD_HELP[helpKey]}
        label={`${children} - wyjaśnienie`}
      />
    </div>
  );
}
